export const availableRoles = {
  Administrador: "admin",
  Analítica: "analytics",
  Normalización: "normalizacion",
  Pricing: "pricing",
  Comercial: "ventas",
};
